import type { SVGProps } from 'react';

const SvgLiveBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M7.99989 8C5.33322 10.2092 5.33322 13.7908 7.99989 16M15.9999 16C18.6666 13.7908 18.6666 10.2092 15.9999 8M5 5C1 8.866 1 15.134 5 19M19 19C23 15.134 23 8.866 19 5M11.7997 14C12.9042 14 13.7997 13.1045 13.7997 12C13.7997 10.8954 12.9042 10 11.7997 10C10.6951 10 9.79969 10.8954 9.79969 12C9.79969 13.1045 10.6951 14 11.7997 14Z'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgLiveBd;
